// packages/shared-hooks/src/engagements/keys.ts
//
// Query-key factory for the CRM v4 Engagement READ surface (#2257 M8 / #2247
// M6). Reads only — the projection is written by the legacy Lead bridge (M7),
// so there are no engagement mutations to invalidate these keys. Legacy
// `/leads/*` writes invalidate `leadsKeys`; the card/list refetch on their own
// `staleTime`/refocus. Mirrors the `leadsKeys` shape (#1081).
// WHY (#2304): request header a client sends to opt into the additive CRM v4
//   fidelity wire fields. The backend parses the lowercase form
//   (`x-magimp-crm-v4-fidelity`) in `apps/backend/.../crm-v4-fidelity-flag.ts`;
//   HTTP header names are case-insensitive so this canonical-case value matches.
//   Duplicated (not imported) here because packages must NOT depend on apps.
export const CRM_V4_FIDELITY_HEADER = 'X-Magimp-Crm-V4-Fidelity';
export const CRM_V4_SCOPE_UI_HEADER = 'X-Magimp-Crm-V4-Scope-Ui';

export const engagementsKeys = {
  all: ['engagements'] as const,
  lists: () => ['engagements', 'list'] as const,
  // WHY (#2304): the `fidelity` suffix is appended ONLY when a caller opts into
  //   the `X-Magimp-Crm-V4-Fidelity` header, so the header-enabled response
  //   (extra keys) never shares a cache slot with the default read. The DEFAULT
  //   `list(filter)` key stays byte-for-byte unchanged (mirrors `leadsKeys`).
  list: (
    filter: Record<string, unknown>,
    opts?: { fidelity?: boolean; scope?: boolean },
  ): readonly unknown[] => {
    const key: unknown[] = ['engagements', 'list', filter];
    if (opts?.fidelity) key.push('fidelity');
    if (opts?.scope) key.push('scope');
    return key;
  },
  details: () => ['engagements', 'detail'] as const,
  detailByLead: (leadId: string, opts?: { fidelity?: boolean }) =>
    opts?.fidelity
      ? (['engagements', 'detail', 'by-lead', leadId, 'fidelity'] as const)
      : (['engagements', 'detail', 'by-lead', leadId] as const),
  checklist: (engagementId: string) => ['engagements', 'checklist', engagementId] as const,
};
